import React, { Component } from 'react'
import styled from 'styled-components'
import Checklist from './Checklist'
import NotesUtil from '../../helpers/NotesUtil'

const Container = styled.div`
  margin: 8px 0;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 0 10px 0;
`
const Title = styled.h3`
  height: 22px;
  margin: 0;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
`
const SubTitle = styled.div`
  height: 19px;
  margin: 0;
  color: #6A6A6A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  display: flex;
`
const AccessText = styled.div`
display: inline-flex;
color: #808284;
margin-top: 12px;
font-size: 14px;
`;
const HideCompleted = styled.div`
  margin-left: 15px;
  height: 19px;
  width: 127px;
  color: #48A3D1;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  text-align: end;
`;

const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #DBDBDC;
  margin-bottom: 10px;
`
const Items = styled.div`
  padding: 8px;
  transition: background-color 0.2s ease;
  background-color: 'white'
`

export default class ChecklistItems extends Component {
  constructor(props) {
    super(props)
    const { checklistItems } = props.loan
    this.state = {
      items: checklistItems,
      hideComplete: false,
    }
  }

  onHideShowComplete = () => {
    const { hideComplete } = this.state
    this.setState({
      ...this.state,
      hideComplete: !hideComplete,
    })
  }

  onItemClick = (rid, markAsRead) => {
    const { items } = this.state
    items.map(item => {
      if (item.rid === rid){
        item.markAsRead = markAsRead
      }
      return item
    })
    this.setState({
      ...this.state,
      items,
    })
  }

  renderChecklist = items => {
    return (
      <Items>
        {(items.map(({ rid, markAsRead, description }) => (
          <Checklist
            key={rid}
            className='itemClass'
            checked={markAsRead}
            notificationId={rid}
            description={description}
            onItemClick={this.onItemClick}
          />
        ))
        )}
      </Items>
    )
  }

  get checkedItems() {
    const { items } = this.state
    return items.filter(({ markAsRead }) => markAsRead)
  }

  get unCheckedItems() {
    const { items } = this.state
    return items.filter(({ markAsRead }) => !markAsRead)
  }

  render() {
    const { items, hideComplete } = this.state
    const { isBankUser } = this.props
    const title = 'Checklist items'
    const subTitle = 'Review the following items and check off as they are completed.'
    const showActionButton = !isBankUser && this.checkedItems.length > 0
    return (
      <Container>
        <Header>
          <Title>{title}</Title>
          {!isBankUser && (
            <AccessText>
              {NotesUtil.getAccessText(isBankUser)}
            </AccessText>
          )}
        </Header>
        <Line/>
        <Header>
          <SubTitle>{subTitle}</SubTitle>
          {showActionButton && (
            <HideCompleted
              id='hideComplete'
              onClick={this.onHideShowComplete}
            >
              {hideComplete ? 'Show' : 'Hide'} Completed
            </HideCompleted>
          )}
        </Header>
        {!hideComplete && this.renderChecklist(items)}
        {hideComplete && this.renderChecklist(this.unCheckedItems)}
      </Container>
    )
  }
}
